(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["cv2-header"] && !Shopify.designMode) return;
  try {
    
(function(){
  var d = document, html = d.documentElement;
  var gross = window.matchMedia ? window.matchMedia('(min-width: 901px)') : { matches: true };

  /* Desktop-Panels unter den Reitern */
  var nav = d.querySelector('.c2-reiter');
  if (nav) {
    var offen = null, zeit = 0;
    var reiter = [].slice.call(nav.children).filter(function(n){ return n.tagName === 'A'; });
    function zu(){ if (!offen) return; offen.p.hidden = true; offen.l.setAttribute('aria-expanded', 'false'); offen = null; }
    function auf(l){
      var id = l.getAttribute('data-c2-panel'), p = id ? d.getElementById(id) : null;
      if (!p) { zu(); return; }
      if (offen && offen.p === p) return;
      zu(); p.hidden = false; l.setAttribute('aria-expanded', 'true'); offen = { p: p, l: l };
    }
    reiter.forEach(function(l){
      l.addEventListener('mouseenter', function(){ if (!gross.matches) return; clearTimeout(zeit); zeit = setTimeout(function(){ auf(l); }, offen ? 0 : 90); });
      l.addEventListener('mouseleave', function(){ clearTimeout(zeit); });
      l.addEventListener('focus', function(){ if (gross.matches) auf(l); });
    });
    nav.addEventListener('mouseleave', function(){ clearTimeout(zeit); zu(); });
    nav.addEventListener('focusout', function(){ setTimeout(function(){ if (!nav.contains(d.activeElement)) zu(); }, 0); });
    d.addEventListener('keydown', function(e){ if (e.key === 'Escape' && offen) { var l = offen.l; zu(); l.focus(); } });
    if (gross.addEventListener) gross.addEventListener('change', zu);
  }

  /* Such-Overlay */
  var such = d.getElementById('c2-such'), ausloeser = null;
  function suchZu(){
    if (!such || such.hidden) return;
    such.classList.remove('auf'); html.style.overflow = '';
    setTimeout(function(){ such.hidden = true; }, 200);
    if (ausloeser && ausloeser.focus) ausloeser.focus();
  }
  function suchAuf(k){
    ausloeser = k; such.hidden = false; html.style.overflow = 'hidden';
    requestAnimationFrame(function(){ such.classList.add('auf'); });
    var q = such.querySelector('input[name="q"]'); if (q) q.focus();
  }
  if (such) {
    [].forEach.call(d.querySelectorAll('[data-c2-such-auf]'), function(k){
      k.addEventListener('click', function(e){ e.preventDefault(); suchAuf(k); });
    });
    [].forEach.call(such.querySelectorAll('[data-c2-such-zu]'), function(k){ k.addEventListener('click', suchZu); });
    such.addEventListener('keydown', function(e){
      if (e.key === 'Escape') { e.stopPropagation(); suchZu(); return; }
      if (e.key !== 'Tab') return;
      var f = [].filter.call(such.querySelectorAll('a[href],button,input:not([type="hidden"])'), function(x){ return x.offsetParent !== null && x.tabIndex !== -1; });
      if (!f.length) return;
      var erst = f[0], letzt = f[f.length - 1];
      if (e.shiftKey && d.activeElement === erst) { e.preventDefault(); letzt.focus(); }
      else if (!e.shiftKey && d.activeElement === letzt) { e.preventDefault(); erst.focus(); }
    });
  }

  /* Vorschläge: /search/suggest.json, 200 ms entprellt, bis 4 Produkte */
  function geld(betrag, format){
    var c = Math.round(parseFloat(betrag || 0) * 100);
    /* Ganze Euro ohne ",00" wie money_without_trailing_zeros im ganzen Shop */
    var ganz = c % 100 === 0;
    function teile(n, dez, tausend, komma){
      if (ganz) dez = 0;
      var s = (n / 100).toFixed(dez).split('.');
      s[0] = s[0].replace(/\B(?=(\d{3})+(?!\d))/g, tausend);
      return s[1] ? s[0] + komma + s[1] : s[0];
    }
    var f = format || '';
    var m = f.match(/\{\{\s*(\w+)\s*\}\}/);
    if (!m) return teile(c, 2, '.', ',') + ' €';
    var w;
    switch (m[1]) {
      case 'amount': w = teile(c, 2, ',', '.'); break;
      case 'amount_no_decimals': w = teile(c, 0, ',', '.'); break;
      case 'amount_no_decimals_with_comma_separator': w = teile(c, 0, '.', ','); break;
      case 'amount_with_apostrophe_separator': w = teile(c, 2, "'", '.'); break;
      default: w = teile(c, 2, '.', ',');
    }
    return f.replace(m[0], w);
  }
  function bildUrl(u){ if (!u) return ''; return u + (u.indexOf('?') > -1 ? '&' : '?') + 'width=120'; }

  [].forEach.call(d.querySelectorAll('form[data-c2-vor]'), function(form){
    var feld = form.querySelector('input[name="q"]'), liste = form.querySelector('.c2-vor');
    var url = form.getAttribute('data-url') || '/search/suggest', format = form.getAttribute('data-geld');
    var aus = ',' + (form.getAttribute('data-aus') || '2-1-gratis-nails-set').toLowerCase().replace(/\s+/g, '') + ',';
    if (!feld || !liste || !window.fetch) return;
    var zeit = 0, ctrl = null;
    function leer(){ liste.hidden = true; liste.textContent = ''; }
    function zeige(ps, q){
      liste.textContent = '';
      /* Ausgeblendet: cv2_ausblenden (data-aus), versteckte Upsell-Produkte (Upgrade) und das alte Nägel-Set */
      ps = ps.filter(function(p){
        var h = String(p.handle || '').toLowerCase(), t = String(p.title || '').toLowerCase();
        return aus.indexOf(',' + h + ',') === -1 && t.indexOf('upgrade') === -1 && h.indexOf('-upgrade') === -1;
      });
      if (!ps.length) { leer(); return; }
      ps.slice(0, 4).forEach(function(p){
        var a = d.createElement('a'); a.href = p.url;
        var im = d.createElement('img'); im.alt = ''; im.width = 48; im.height = 48; im.loading = 'lazy';
        var src = bildUrl(p.image || (p.featured_image && p.featured_image.url)); if (src) im.src = src;
        a.appendChild(im);
        var n = d.createElement('span'); n.className = 'n'; n.textContent = p.title; a.appendChild(n);
        var pr = d.createElement('span'); pr.className = 'pr';
        /* Ein Preis wie überall im Shop: kein "ab", Startpreis wie die Karte (erste Variante) */
        pr.textContent = geld(p.price || p.price_min, format);
        a.appendChild(pr);
        liste.appendChild(a);
      });
      var alle = d.createElement('a'); alle.className = 'alle';
      alle.href = form.getAttribute('action') + '?q=' + encodeURIComponent(q) + '&type=product&options%5Bprefix%5D=last';
      alle.textContent = 'Alle Treffer zeigen';
      liste.appendChild(alle);
      liste.hidden = false;
    }
    function hole(){
      var q = feld.value.trim();
      if (q.length < 2) { if (ctrl) ctrl.abort(); leer(); return; }
      if (ctrl) ctrl.abort();
      ctrl = window.AbortController ? new AbortController() : null;
      var adr = url + '.json?q=' + encodeURIComponent(q) + '&resources%5Btype%5D=product&resources%5Blimit%5D=10&resources%5Boptions%5D%5Bunavailable_products%5D=last';
      fetch(adr, { headers: { 'Accept': 'application/json' }, signal: ctrl ? ctrl.signal : undefined })
        .then(function(r){ return r.json(); })
        .then(function(j){
          if (feld.value.trim() !== q) return;
          var ps = j && j.resources && j.resources.results && j.resources.results.products ? j.resources.results.products : [];
          zeige(ps, q);
        })
        .catch(function(){});
    }
    feld.addEventListener('input', function(){ clearTimeout(zeit); zeit = setTimeout(hole, 200); });
    feld.addEventListener('focus', function(){ if (liste.children.length && feld.value.trim().length > 1) liste.hidden = false; });
    form.addEventListener('keydown', function(e){
      var zeilen = [].slice.call(liste.querySelectorAll('a'));
      if (liste.hidden || !zeilen.length) return;
      var i = zeilen.indexOf(d.activeElement);
      if (e.key === 'ArrowDown') { e.preventDefault(); (zeilen[i + 1] || zeilen[0]).focus(); }
      else if (e.key === 'ArrowUp') { e.preventDefault(); if (i > 0) zeilen[i - 1].focus(); else feld.focus(); }
      else if (e.key === 'Escape' && !form.closest('.c2-such')) { liste.hidden = true; feld.focus(); }
    });
    d.addEventListener('click', function(e){ if (!form.contains(e.target)) liste.hidden = true; });
  });
})();

  } catch(e) { console.error(e); }
})();
})();
